const goodsList = () => import('@/views/main/goods/list/list.vue')
export default {
  path: '/main/goods/list',
  name: 'goodsList',
  component: goodsList,
  children: []
}
